import { Pipe, PipeTransform} from '@angular/core';
import { CopyService } from './copy.service';
import { ContentService } from './content.service';


@Pipe({
  name: 'copy'
})
export class CopyPipe implements PipeTransform {
  copyValue;
  constructor(private copyService: CopyService,private contentService: ContentService) { }

  transform(value: string) {
    return this.copyService.getCopyByKey(value).then((res:string) => {
      if(res.indexOf(':CD:')>-1){
        return this.contentService.getContentByValue(res.substring(4)).then((res2)=>{
          return res2;
        });
      }else{
        return res;
      }
      
    });

  }

}
